import type { IProducts, ISearchState } from '../interfaces';

export const formatSearchPrice = (price?: number | null) => (
  typeof price === 'number' ? `$${price.toFixed(2)}` : null
);

export const getSearchResultDetails = (product: IProducts) => [
  product.productTypeName,
  product.selectedMaterial,
  product.gender,
].filter(Boolean) as string[];

export const getSearchResultImage = (
  materialImages: ISearchState['materialImages'],
  productId: string
) => materialImages[productId]?.[0]?.image?.publicUrl;
